export default __webpack_public_path__ + "static/media/G-ROCKET.e3d702cf.jpg";